<template>
    <div class="ajuste">
      <div class="blocoA" v-for="(n,i) in dados" :key="i" @click="abrirLink(n.link)">       
          <div>
             
            <img src="/sandboxfront/img/documento.svg" alt="" v-if="$route.params.id == 2" style="width: 40px;    height: 40px;"/>
            <img src="/sandboxfront/img/bilhete.svg" alt="" v-if="$route.params.id == 3" style="width: 40px;    height: 40px;"/>
            <img src="/sandboxfront/img/platilha.svg" alt="" v-if="$route.params.id == 5" style="width: 40px;    height: 40px;"/>
            <div class="tipo" v-if="$route.params.id != 5 || $route.params.id != 4">
                {{n.tipo}}
            </div>
          </div>
          <span class="titulo" v-html="n.titulo"></span>
          <div v-html="n.descricao" class="descricao" v-if="t!='federal'">
          </div>  
          <div v-html="n.subtitulo" class="descricao" v-else>
          </div>        
      </div>   
  </div>
</template>

<script>
export default {
    props:['dados','t'],      
    methods:{
        abrirLink(link){
            window.open(link,'_blank')
        }
    }

}
</script>

<style>
.ajuste{
    padding: 10px 30px;  
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;    
    margin: 0px auto;    
    box-sizing: border-box;
 grid-gap: 18px;

}
div.blocoA .tipo{
    background: #4A154B;
    border-radius: 5px;
    color: #fff;
    font-weight: bold;  
    text-align: center;
    font-size: 0.75em;
    padding: 1px 20px;
    margin-top:10px;
}
div.blocoA .titulo{
    font-weight: bold;
    margin-bottom: 0px;
    letter-spacing: -1px;
    text-align: justify;
}
div.blocoA .descricao{
    font-size: 0.75em;
    text-align: justify;
}
div.blocoA{   
height: 100%;
display: flex;
flex-direction: column;
justify-content: space-between;
text-align: justify;
background: #EDE4ED;
border: 1px solid #4A154B;
box-sizing: border-box;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 10px;
margin-top:10px;
padding:10px;
cursor: pointer;
    align-items: flex-start;
}


@media screen and (max-width: 900px) {
.ajuste{    
    grid-template-columns: repeat(2, 1fr);
}
}
@media screen and (max-width: 600px) {
    .ajuste{ 
    grid-template-columns: repeat(1, 1fr) !important;
    
}
div.blocoA .descricao{
    font-size: 1em;
}
}
</style>